import { useEffect, useState } from "react";
import styles from "./ABC.module.css";
import { initializeApp } from "firebase/app";
import { getAuth, signInWithEmailAndPassword, onAuthStateChanged } from "firebase/auth";

// ✅ Your Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyCgjec6fE-qnvltlXK_MUlVA3n_2W-1AUA",
  authDomain: "my-portfolio-8f46e.firebaseapp.com",
  databaseURL: "https://my-portfolio-8f46e-default-rtdb.firebaseio.com",
  projectId: "my-portfolio-8f46e",
  storageBucket: "my-portfolio-8f46e.firebasestorage.app",
  messagingSenderId: "441553258383",
  appId: "1:441553258383:web:2ef547dbb229beea566dfa",
  measurementId: "G-5MR4XMTCR2",
};

// ✅ Init Firebase once
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

let Checking = () => {
  const [data, setData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [deleting, setDeleting] = useState([]);

  // 🔐 Login states
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [user, setUser] = useState(null);
  const [error, setError] = useState("");

  // 🔐 Handle Login
  const handleLogin = (e) => {
    e.preventDefault();
    signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        setUser(userCredential.user);
        setError("");
      })
      .catch((err) => {
        setError("Invalid credentials");
      });
  };

  // 🔐 Auth State Change
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);

  // ✅ Fetch data only if logged in
  useEffect(() => {
    if (!user) return;
    const fetchData = async () => {
      const token = await user.getIdToken();
      fetch(
        `https://my-portfolio-8f46e-default-rtdb.firebaseio.com/data.json?auth=${token}`
      )
        .then((res) => res.json())
        .then((data) => {
          if (data) {
            let nestedObjects = Object.entries(data).map(([id, val]) => ({
              id,
              ...val,
            }));
            setData(nestedObjects);
          }
        })
        .catch((err) => setError("Permission denied or error fetching data"));
    };
    fetchData();
  }, [user]);

  // ✅ Delete
  const handleDelete = async () => {
    if (!user) return;
    setDeleting(selectedRows);
    setTimeout(async () => {
      for (let id of selectedRows) {
        const token = await user.getIdToken();
        await fetch(
          `https://my-portfolio-8f46e-default-rtdb.firebaseio.com/data/${id}.json?auth=${token}`,
          { method: "DELETE" }
        );
      }
      setData((prev) => prev.filter((row) => !selectedRows.includes(row.id)));
      setSelectedRows([]);
      setDeleting([]);
    }, 500);
  };

  // ✅ Format time
  const formatTime12Hour = (timeString) => {
    if (!timeString) return "";
    let date = new Date(timeString);
    if (isNaN(date.getTime())) {
      const [hours, minutes] = timeString.split(":");
      date = new Date();
      date.setHours(Number(hours), Number(minutes));
    }
    return date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  // 🔐 If not logged in → show login form
 // Inside your component (replace the login part)
if (!user) {
  return (
    <div className={styles.loginContainer}>
      <div className={styles.glassCard}>
        <h2 className={styles.title}>Welcome Back</h2>
        <p className={styles.subtitle}>Sign in to continue</p>

        <form onSubmit={handleLogin} className={styles.form}>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className={styles.input}
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className={styles.input}
          />

          <button type="submit" className={styles.loginBtn}>
            Log In
          </button>
        </form>

        {error && <p className={styles.error}>{error}</p>}
      </div>
    </div>
  );
}


  // ✅ If logged in but data not loaded
  if (data.length === 0) {
    return <div className={styles.loading}>Loading...</div>;
  }

  const columns = Object.keys(data[0]).filter((c) => c !== "id");

  return (
    <div className={styles.checking}>
      <div className={styles.header}>
        <p className={styles.title}>
          <b>{data.length} Visitors</b>
        </p>
        {selectedRows.length > 0 && (
          <button className={styles.deleteBtn} onClick={handleDelete}>
            🗑 Delete
          </button>
        )}
      </div>

      <div className={styles.tableWrapper}>
        <table className={styles.animatedTable}>
          <thead>
            <tr>
              <th></th>
              {columns.map((column, index) => (
                <th key={index}>{column}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data
              .slice()
              .reverse()
              .map((row) => (
                <tr
                  key={row.id}
                  className={`${styles.row} 
                    ${selectedRows.includes(row.id) ? styles.selectedRow : ""} 
                    ${deleting.includes(row.id) ? styles.deletingRow : ""}`}
                >
                  <td>
                    <input
                      type="checkbox"
                      checked={selectedRows.includes(row.id)}
                      onChange={() =>
                        setSelectedRows((prev) =>
                          prev.includes(row.id)
                            ? prev.filter((x) => x !== row.id)
                            : [...prev, row.id]
                        )
                      }
                    />
                  </td>
                  {columns.map((column, colIndex) => (
                    <td
                      key={colIndex}
                      className={column === "date" ? styles.dateCell : ""}
                    >
                      {column.toLowerCase().includes("time")
                        ? formatTime12Hour(row[column])
                        : row[column]}
                    </td>
                  ))}
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Checking;
